<template>
  <div>
    <img :src="captImg" height="100%" v-show="false"/>
    <canvas ref="canvas" id="canvas" width="1000" height="1350" v-show="false"/>

    <div class="ocrSpinner" v-if="captImg!=null">
      <q-spinner size="25px" color="primary"/>
      <div style="margin-top:10px">OCR läuft...</div>
    </div>

    <div class="row justify-center">
      <video ref="video" width="500" id="video" autoplay playsinline="playsinline" :style="captImg!=null?'visibility:hidden;':''"/>
    </div>
    <!--
        <div class="row justify-end">
                  <video ref="video" width="400" height="400" id="video" autoplay playsinline="true" style="border: 2px solid red;"/>
          <q-btn color="secondary" label="Start OCR" @click="doOCR" class="q-ma-sm"/>
        </div>
    -->
  </div>
</template>

<script>
  import { createWorker } from 'tesseract.js'

  export default {
    name: 'ocr-comp',
    data() {
      return {
        video: {},
        canvas: {},
        captImg: null,
        stream: null
      }
    },

    methods: {
      capture() {
        this.canvas = this.$refs.canvas
        var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 1000, 1350);
        this.captImg = this.canvas.toDataURL("image/png")
      },

      async start() {
        console.info('[OCR] Kamera-Initialisierung gestartet')
        this.$emit('OCRInitStarted')
        this.video = this.$refs.video;
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          const error = new Error('navigator.mediaDevices.getUserMedia ist nicht verfügbar. HTTPS ist möglicherweise erforderlich.')
          error.name = 'StreamApiNotSupportedError'
          console.debug('[OCR] Status der Kamera-API', {
            mediaDevicesAvailable: Boolean(navigator.mediaDevices),
            getUserMediaAvailable: Boolean(navigator.mediaDevices?.getUserMedia),
            secureContext: window.isSecureContext
          })
          this.$emit('OCRError', error)
          return
        }

        try {
          try {
            console.debug('[OCR] Versuche die rückseitige Kamera zu öffnen')
            this.stream = await navigator.mediaDevices.getUserMedia({video: {facingMode: {exact: "environment"}}})
            console.debug('[OCR] Rückseitiger Kamerastream wurde bereitgestellt')
          } catch (preferredCameraError) {
            console.warn('[OCR] Rückkamera konnte nicht geöffnet werden; versuche eine beliebige Kamera.', preferredCameraError)
            this.stream = await navigator.mediaDevices.getUserMedia({video: true})
            console.debug('[OCR] Alternativer Kamerastream wurde bereitgestellt')
          }

          console.debug('[OCR] Verbinde Kamerastream mit dem Videoelement')
          this.video.srcObject = this.stream
          await this.video.play()
          console.info('[OCR] Kamera wurde erfolgreich initialisiert und das Videobild läuft')
          this.$emit('OCRReady')
        } catch (error) {
          this.stop()
          this.$emit('OCRError', error)
        }
      },

      stop() {
        console.debug('[OCR] Kamerastream wird beendet', {
          streamAvailable: Boolean(this.stream)
        })
        if (this.video && typeof this.video.pause === 'function') {
          this.video.pause()
          this.video.srcObject = null
        }
        this.stream?.getTracks().forEach(track => track.stop())
        this.stream = null
      },

      // -----------------------------------------------------------
      // ------------------------- OCR Scan ------------------------
      // -----------------------------------------------------------
      async doOCR() {
        console.info('[OCR] Aufnahme und Texterkennung gestartet')
        this.capture()
        var hostname = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        const worker = createWorker({
          workerPath: hostname + '/statics/ocr/worker.js',
          corePath: hostname + '/statics/ocr/tesseract-core.js',
          langPath: hostname + '/statics/ocr/'
        })

        try {
          await worker.load()
          await worker.loadLanguage('deu');
          await worker.initialize('deu');
          let result = await worker.recognize(this.captImg) //{ lang: 'deu'}  "http://localhost:8090/statics/ocr.png"
          logger.info("OCR result", result)
          this.captImg = null
          this.$emit('OCRDone', result.data.text)
        } catch (e) {
          console.error('[OCR] Texterkennung ist fehlgeschlagen', e)
          logger.error("OCR error", e)
        }
      }
    },

    beforeUnmount: function () {
      this.stop()
      this.eventBus.off('onOCR', this.doOCR)
    },

    destroyed: function () {
      logger.info('Destroyed');
    },

    mounted() {
      console.debug('[OCR] OCR-Komponente wurde eingebunden')
      this.start()
      this.eventBus.on('onOCR', this.doOCR)
    }
  }
</script>

<style lang="sass">
  .ocrSpinner
    position: absolute
    top:50%
    left: 0
    width: 100%
    text-align: center
    font-size:13px
</style>
